<script setup lang="ts">
import { services } from '~/components/services/relax/sauna/carousel';

useSeoMeta({
  title: 'Sauny | Okgym - Fitcentrum | Pardubický Kraj',
  description:
    'Fitness, Gym, Solarium, Box - Lepší nabídku nenajdeš! Pro studenty zvýhodněná nabídka jen v Okgym',
});

const text = {
  title: 'Zastavte se v každodenním chaosu a věnujte čas pouze sobě.',
  subtitle: 'Sauny',
  description:
    'Střídání tepla a chladu posílí vaši imunitu v boji proti rýmě a chřipkám, ochrání srdce a nastartuje hloubkový detox celého organismu. Záplava endorfinů spolehlivě odplaví stres, zlepší spánek a uleví bolavým svalům i kloubům. Přijďte si pro zdraví a absolutní klid.',
} as const;
</script>

<template>
  <PageContainer no-alignment no-padding>
    <SlugHeader
      :title="text.title"
      :subtitle="text.subtitle"
      :description="text.description"
      icon="icon:sauna"
      :image-header="{
        url: '/images/sauna/header.webp',
        alt: 'Lezecká stěna',
      }"
      :links="[
        {
          to: '/cenik-sauny.pdf',
          label: 'Ceník',
          icon: 'icon:document',
        },
      ]"
    />
    <SlugBody :items="services" />
    <Feed />
    <IndexGallery />
  </PageContainer>
</template>
